import { render } from "./PokemonEvolution.vue?vue&type=template&id=7ab3a780&scoped=true"
import script from "./PokemonEvolution.vue?vue&type=script&lang=js"
export * from "./PokemonEvolution.vue?vue&type=script&lang=js"

import "./PokemonEvolution.vue?vue&type=style&index=0&id=7ab3a780&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab3a780"]])

export default __exports__